import React from 'react';
import { useField, useForm } from 'react-final-form';
import { Fieldset } from '@estimateone/frontend-components';
import FileUploader from '../../../FileUploader';
import { QuoteFile } from '../../QuoteFiles';
import { FileManagerParams } from '@shared/FileUploader/types';
import { FieldWrapper } from '@shared/FinalForm/Field';
import {
  QuoteFileAction,
  QuoteFormCommonFieldName,
  UploadRestriction,
  UploadCategory,
} from '@ascension/enums';
import { QuoteFileValue, QuoteFormsValues } from '../types';

const QuoteFileField = ({
  fileManagerEndpoint,
  fileManagerKey,
  fileManagerLocale,
  parentType,
  parentId,
}: FileManagerParams) => {
  const {
    change: updateFieldValue,
    mutators: { setFieldTouched },
  } = useForm<QuoteFormsValues>();

  const {
    input: { value: quoteFile },
    meta: { error, submitError, touched },
  } = useField<QuoteFileValue>(QuoteFormCommonFieldName.QuoteFile);

  return (
    <FieldWrapper errors={error || submitError} showErrors={touched}>
      <Fieldset
        tabIndex={0}
        name={QuoteFormCommonFieldName.QuoteFile}
        id="quote-file"
        legend="Quote file"
        onBlur={() => setFieldTouched(QuoteFormCommonFieldName.QuoteFile, true)}
        isRequired
      >
        {quoteFile ? (
          <QuoteFile
            action={QuoteFileAction.Remove}
            file={quoteFile}
            onRemove={() => updateFieldValue(QuoteFormCommonFieldName.QuoteFile, undefined)}
          />
        ) : (
          <FileUploader
            fileManagerEndpoint={fileManagerEndpoint}
            fileManagerKey={fileManagerKey}
            fileManagerLocale={fileManagerLocale}
            maxFiles={1}
            uppyOptions={{
              id: 'quote',
              locale: { strings: { dropHereOr: 'Drag & drop your quote file here, or' } },
              restrictions: { maxFileSize: UploadRestriction.MaxEmailAttachmentSize },
            }}
            category={UploadCategory.QUOTE}
            parentType={parentType}
            parentId={parentId}
            onUploadComplete={([file]) =>
              updateFieldValue(QuoteFormCommonFieldName.QuoteFile, file)
            }
          />
        )}
      </Fieldset>
    </FieldWrapper>
  );
};

export default QuoteFileField;
